const JobsModule = {
  components: {
    Adsense,
  },
  template: `
      <div class="jobs">      
      	<router-view class="uk-margin-xlarge-bottom"></router-view>
      </div>
	`,
};
